module.exports = __webpack_public_path__ + "media/application/images/2022/magazine-dfe32441e58491bcceaac5a2382c6793.jpg";